import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "p-5" }
const _hoisted_2 = { class: "mb-2 text-2xl font-bold tracking-tight text-gray-900 dark:text-white" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3 font-normal text-gray-700 dark:text-gray-400" }, " Description of the guide ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "inline-flex items-center rounded-lg bg-emerald-700 px-3 py-2 text-center text-sm font-medium text-white hover:bg-emerald-800 focus:outline-none focus:ring-4 focus:ring-emerald-300 dark:bg-emerald-600 dark:hover:bg-emerald-700 dark:focus:ring-emerald-800" }, [
  /*#__PURE__*/_createTextVNode(" Start "),
  /*#__PURE__*/_createElementVNode("svg", {
    "aria-hidden": "true",
    class: "ml-2 -mr-1 h-4 w-4",
    fill: "currentColor",
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    /*#__PURE__*/_createElementVNode("path", {
      "fill-rule": "evenodd",
      d: "M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z",
      "clip-rule": "evenodd"
    })
  ])
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createBlock(_component_router_link, {
    to: '/guides/' + _ctx.ID,
    class: "max-w-sm rounded-lg border border-gray-200 bg-white shadow dark:border-gray-700 dark:bg-gray-800"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h5", _hoisted_2, _toDisplayString(_ctx.Title), 1),
        _hoisted_3,
        _hoisted_4
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}